export enum WorkType {
    CREATE_FUNCTION = 1,
    UPDATE_FUNCTION = 2,
    DESCRIBE_FUNCTION = 3,
    REVIEW_TASK = 4,
    OPEN_TASK = 5,
    CREATE_REACT_COMPONENT = 6,
    UPDATE_REACT_COMPONENT = 7,
    CHECK_REUSABILITY = 8,
    CODING = 9,
    COMMUNITY_REVIEW = 11,
    RESOLVE_CONFLICTS = 12,
    QUEST_REVIEW = 13,
    IMPLEMENTATION_PLAN = 14,
    QUEST_BREAKDOWN = 15,
    REVIEW_REQUEST_REJECTION = 16,
    PLANNING_QUESTIONS_ANSWERING = 17,
    AI_QUEST_REVIEW = 18
}

export enum ReviewStatus {
    INADEQUATE = 1,
    REQUIRES_MODIFICATION = 2,
    ADEQUATE = 3
}
